/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ url: NonNullable<unknown> }} Welcome_Back_IntroInputs */

const fr_welcome_back_intro = /** @type {(inputs: Welcome_Back_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cette adresse (${i?.url}) remplace désormais l'instance locale que vous aviez l'habitude d'utiliser.`)
};

const en_welcome_back_intro = /** @type {(inputs: Welcome_Back_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This address (${i?.url}) now replaces the local instance you used to use.`)
};

/**
* | output |
* | --- |
* | "This address ({url}) now replaces the local instance you used to use." |
*
* @param {Welcome_Back_IntroInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const welcome_back_intro = /** @type {((inputs: Welcome_Back_IntroInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Back_IntroInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_welcome_back_intro(inputs)
	return en_welcome_back_intro(inputs)
});